import React, { useContext, useEffect, useState } from 'react';
import { checkMonthlyDue} from '../../apis';
import { AppContext } from '../../appContext';
import useDeviceType from '../../utils/useDeviceType';
import AmountPayDueMOB from '../../PageComponentData/wallet/AmountPayDueMobile';
import AmountPayDueWeb from '../../PageComponentData/wallet/AmountPayDueDesktop';
import RegularMonthDueV1 from './RegularMonthDuev1';
import PayMonthlyDueV1 from './PayLastMonthDuev1';
import PayLastMonthDue from './PayLastMonthDue';
import RegularMonthDue from './RegularMonthDue';

function PayBill({ closeFunction }) {
  
  const deviceType = useDeviceType();
  const { loggedInUser } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [dueAmountDetails, setDueAmountDetails] = useState(null);
  const toCheckMonthlyDue = async (id) => {
    try {
      const res = await checkMonthlyDue(id);
      if (res.status === 200) {
        console.log(res);
        setDueAmountDetails(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    toCheckMonthlyDue(loggedInUser?.data?.hospitalProfile?._id);
  }, [loggedInUser]);
  if (loader) {
    return null;
  }

  return (
    <>
      {dueAmountDetails?.duepaid ? (
        <>
          {(deviceType == 'Mobile' || deviceType == 'Tablet') ? (
            <AmountPayDueMOB isOpen={true} closefun={closeFunction}>
              <RegularMonthDueV1 closeFunction={closeFunction} />
            </AmountPayDueMOB>
          ) : (
            <AmountPayDueWeb isOpen={true} closefun={closeFunction} isRegular={true}>
              <RegularMonthDueV1 closeFunction={closeFunction} />
            </AmountPayDueWeb>
          )}
        </>

        //  <RegularMonthDue closeFunction={closeFunction} />
      ) : (
        <>
        {(deviceType == 'Mobile' || deviceType == 'Tablet') ? (
            <AmountPayDueMOB isOpen={true} closefun={closeFunction}>
              <PayMonthlyDueV1 closeFunction={closeFunction} />
            </AmountPayDueMOB>
          ) : (
            <AmountPayDueWeb isOpen={true} closefun={closeFunction} isRegular={true}>
               <PayMonthlyDueV1 closeFunction={closeFunction} />
            </AmountPayDueWeb>
          )}
        </>
        //<PayLastMonthDue closeFunction={closeFunction} />
      )}
    </>
  );
}

export default PayBill;
